<template>
    <ul class="tree">
        <TreeItem v-for="item in items" :key="item.id" :item="item" @update="update" />
    </ul>
</template>

<script>
import TreeItem from "@/components/Tree/TreeItem";

export default {
    name: "Tree",
    components: {
        TreeItem
    },
    props: ["items"],
    methods: {
        update(changedItem) {
            const copy = [...this.items];
            const changedIndex = copy.findIndex(
                item => item.id === changedItem.id
            );
            copy[changedIndex] = changedItem;
            this.$emit("update", copy);
        }
    }
};
</script>